import { writeRefusalCopy, type IWriteFailureCopy } from '../../SchedulerPage/lib/writeRefusalCopy';

/** What the page says when a tracker cell's write didn't land — i18n keys. */
export type ITrackerWriteFailure = IWriteFailureCopy;

/**
 * The copy for a failed cell write: a deliberate refusal says why
 * (`writeRefusalCopy`). Anything else: the cell now shows what the server
 * holds (it was re-read), so the copy says that — never "nothing changed",
 * which a part-way write would make false (QA R-04).
 */
export function trackerWriteFailure(error: unknown): ITrackerWriteFailure {
  return writeRefusalCopy(error) ?? { title: 'activities.tracker.writeFailed', sub: 'activities.tracker.writeFailedSub' };
}
